import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import {
  DetailInfo,
  DetailRow,
} from '../../../../common/components/DetailRow/DetailRow'
import { BoxV4 } from '@labrav/react-components'

import { useStyles } from './OfferDetails.styles'
import { CombinedFormState } from '../../../../modules/combinedForm/reducer'
import { getCurrencyLabelForDisplay } from '../../../../utils/getCurrencyLabelForDisplay'
import { useSelector } from '../../../../store'
import { Product } from '../../../../modules/productsListing/reducer'
import { OfferStatus } from '../../../../modules/privateOffer/reducer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getLocalDateTime } from '../../../../common/utils/dates'
import { isNonEmptyNumber } from '@labrav/common'

interface OfferDetailsProps {
  combinedFormData: CombinedFormState
  viewingPersona: string
}

export default function OfferDetails({
  combinedFormData,
  viewingPersona,
}: OfferDetailsProps) {
  const { classes } = useStyles()
  const {
    formattedDate: offerExpirationDate,
    formattedTime: offerExpirationTime,
  } = getLocalDateTime(combinedFormData.cppoData.offerExpirationDate as string)
  const { formattedDate: usageEndDate } = getLocalDateTime(
    combinedFormData.cppoData.subscriptionEndDate as string
  )
  const productIdToUse = combinedFormData?.resellerAgreementData.awsProductId
  const products = useSelector<Product[]>(
    state => state.productsListing['AWS']?.products?.rows || []
  )
  const product =
    products.find(product => product.productId === productIdToUse) ||
    ({} as Product)

  return (
    <BoxV4
      style={{ padding: '32px' }}
      heading="Offer details"
      headingIcon={
        <FontAwesomeIcon
          icon={faListUl}
          style={{ width: '18px', height: '14px' }}
        />
      }
      variant="small"
      headingVariant="small"
    >
      <div className={classes.section}>
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'Buyer name'}
                value={combinedFormData.resellerAgreementData.companyName}
                keyName={'buyerName'}
              />
              <DetailInfo
                title={'Buyer AWS account ID'}
                value={combinedFormData.resellerAgreementData.buyerAwsAccountId}
                keyName={'buyerAWSAccountId'}
              />
            </>
          }
        />
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'Offer name'}
                value={combinedFormData.resellerAgreementData.agreementName}
                keyName={'offerName'}
              />
              <DetailInfo
                title={'Offer expiration date'}
                value={
                  <div className={classes.createdAtWrapper}>
                    <div className={classes.createdAtDate}>
                      {offerExpirationDate}
                    </div>
                    <div className={classes.createdAtTime}>
                      {offerExpirationTime}
                    </div>
                  </div>
                }
                keyName={'offerExpirationDate'}
              />
            </>
          }
        />
        {combinedFormData.resellerAgreementData.productType ===
          'SAAS_SUBSCRIPTION' && viewingPersona === 'CP' ? (
          <DetailRow
            borderBottom
            children={
              <>
                <DetailInfo
                  title={'Usage end date'}
                  value={usageEndDate}
                  keyName={'usageEndDate'}
                />
                <DetailInfo
                  title={'Marked-up'}
                  value={
                    isNonEmptyNumber(
                      Number(combinedFormData.cppoData.adjustmentPercentage)
                    )
                      ? `${combinedFormData.cppoData.adjustmentPercentage}%`
                      : '-'
                  }
                  keyName={'subscriptionEndDate'}
                />
              </>
            }
          />
        ) : null}
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'ISV'}
                value={combinedFormData.resellerAgreementData.isvName || '-'}
                keyName={'isvName'}
              />
              <DetailInfo
                title={'Product'}
                value={product.productName}
                keyName={'productName'}
              />
            </>
          }
        />
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'Offer description'}
                value={combinedFormData.cppoData.offerDescription}
                keyName={'offerDesc'}
                shortenedValue={true}
              />
              <>
                {!(
                  combinedFormData.cppoData.offerStatus ===
                    OfferStatus.OFFER_CREATION_IN_PROGRESS ||
                  combinedFormData.cppoData.offerStatus ===
                    OfferStatus.OFFER_CREATION_FAILED
                ) &&
                  viewingPersona === 'CP' && (
                    <DetailInfo
                      title="AWS offer ID"
                      value={
                        (combinedFormData.cppoData.cloudOfferId as string) ||
                        '-'
                      }
                      keyName="awsId"
                    />
                  )}
              </>
            </>
          }
        />
        <DetailRow
          borderBottom
          children={
            <>
              <DetailInfo
                title={'Selected currency'}
                value={getCurrencyLabelForDisplay(
                  combinedFormData.resellerAgreementData.currency
                )}
                keyName={'SelectedCurrency'}
              />
              <DetailInfo
                title={'Auto-renewal'}
                value={
                  combinedFormData.resellerAgreementData.renewal ? 'Yes' : 'No'
                }
                keyName={'SelectedCurrency'}
              />
            </>
          }
        />
      </div>
    </BoxV4>
  )
}
